import { render, staticRenderFns } from "./ComplaintsView.vue?vue&type=template&id=5411ecce&scoped=true&lang=pug&"
import script from "./ComplaintsView.vue?vue&type=script&lang=ts&"
export * from "./ComplaintsView.vue?vue&type=script&lang=ts&"
import style0 from "./ComplaintsView.vue?vue&type=style&index=0&id=5411ecce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411ecce",
  null
  
)

export default component.exports